import React from "react";
import {
	Badge,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

export const OperativosFilters = ({
	fechaDesde,
	fechaHasta,
	textoBusqueda,
	filtroOperativo,
	onFechaDesdeChange,
	onFechaHastaChange,
	onMoverRangoFechas,
	onTextoBusquedaChange,
	onFiltroOperativoChange,
	onAplicarFiltroFechas,
	onLimpiarFiltros,
	onVolver,
	onExportarOperativos,
	exporting,
	cantidadFiltros,
	onToggleFiltros,
}) => (
	<Grid container direction="row" justifyContent="start" alignItems="end" spacing={2} sx={{ px: 2 }}>
		<Grid container size={{ xs: 12, md: "auto" }} alignItems="end" spacing={1}>
			<Grid item>
				<Button
					variant="text"
					size="small"
					onClick={() => onMoverRangoFechas?.(-1)}
					sx={{ minWidth: 0, px: 0.5 }}
					aria-label="Restar un dia al rango"
				>
					<ChevronLeftIcon />
				</Button>
			</Grid>

			<Grid item>
				<TextField
					variant="standard"
					label="Fecha desde"
					type="date"
					size="small"
					value={fechaDesde}
					onChange={(event) => onFechaDesdeChange(event.target.value)}
					InputLabelProps={{ shrink: true }}
				/>
			</Grid>

			<Grid item>
				<TextField
					variant="standard"
					label="Fecha hasta"
					type="date"
					size="small"
					value={fechaHasta}
					onChange={(event) => onFechaHastaChange(event.target.value)}
					InputLabelProps={{ shrink: true }}
				/>
			</Grid>

			<Grid item>
				<Button
					variant="text"
					size="small"
					onClick={() => onMoverRangoFechas?.(1)}
					sx={{ minWidth: 0, px: 0.5 }}
					aria-label="Sumar un dia al rango"
				>
					<ChevronRightIcon />
				</Button>
			</Grid>
		</Grid>

		<TextField
			variant="standard"
			label="Buscar parte"
			placeholder="ID, grupo, empresa, delegacion..."
			size="small"
			value={textoBusqueda}
			onChange={(event) => onTextoBusquedaChange(event.target.value)}
		/>

		<FormControl variant="standard" sx={{ minWidth: 170 }}>
			<InputLabel id="filtro-operativo-label">Estado operativo</InputLabel>
			<Select
				labelId="filtro-operativo-label"
				value={filtroOperativo}
				label="Estado operativo"
				onChange={(event) => onFiltroOperativoChange(event.target.value)}
			>
				<MenuItem value="todos">Todos</MenuItem>
				<MenuItem value="no">Pendientes</MenuItem>
				<MenuItem value="si">Operativos</MenuItem>
			</Select>
		</FormControl>

		<Button variant="contained" onClick={onAplicarFiltroFechas}>
			Buscar
		</Button>

		<Button variant="outlined" onClick={onLimpiarFiltros}>
			Limpiar
		</Button>

		<Badge badgeContent={cantidadFiltros} color="primary">
			<Button variant="outlined" onClick={onToggleFiltros}>
				<FilterAltIcon sx={{ fontSize: 20, mr: 0.3, mt: -0.3 }} />
				filtros
			</Button>
		</Badge>

		{/* <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onVolver}>
			Volver a cuadrillas
		</Button> */}

		<Button
			variant="outlined"
			startIcon={<FileDownloadIcon />}
			onClick={onExportarOperativos}
			disabled={exporting}
		>
			{exporting ? "Exportando..." : "Exportar operativos"}
		</Button>
	</Grid>
);
